import React, { useState, useEffect, useRef } from 'react';
import SearchBar from '../../../revampComponents/Atom/SearchBar';
import BackendPaginatedDataTable from '../../../revampComponents/Atom/BackendPaginatedDataTable';
import { DateTimePicker, RainbowThemeContainer } from 'react-rainbow-components';
import SelectExhibitorCategoryModal from './SelectExhibitorCategoryModal';
import IconDate from "../../../revampComponents/Atom/Icons/IconDate.svg";
import moment from "moment";
import { DeleteQuickButton } from '../../../revampComponents/Atom/Buttons';
import syncBtn from '../../../assets/images/mynaui_refresh.svg';

const ExhibitorsNCategoryExhibitorsTable = ({
    toggleLabel = "exhibitor",
    exhibitorItems = [],
    categoryItems = [],
    defaultDueDate = null,
    defaultReminderDate = null,
    onAddExhibitors = () => { },
    onAddCategories = () => { },
    onRemoveExhibitor = () => { },
    onRemoveCategory = () => { },
    onUpdateExhibitorDeadline = () => { },
    onUpdateCategoryDeadline = () => { },
    onSyncAllWithDefaults = () => { },
    onUpdateCategoryDeadlines  = () => { },
    onUpdateExhibitorDeadlines  = () => { },
    allExhibitor = [],
    allCategory = [],
    exhibitorWithEntity = [],
    isEdit = false
}) => {
    const [search, setSearch] = useState("");
    const [filteredList, setFilteredList] = useState([]);
    const [showSelectModal, setShowSelectModal] = useState(false);

    const theme = {
        rainbow: {
            palette: {
                brand: "#002E6E"
            }
        }
    };

    // Get current items based on toggle
    const currentItems = toggleLabel === "exhibitor" ? exhibitorItems : categoryItems;

    // Update filtered list when items or search changes
    useEffect(() => {
        if (search) {
            const filtered = currentItems?.filter(item =>
                (item?.entity_name || item?.category_name || '')
                    .toLowerCase()
                    .includes(search?.toLowerCase()?.trim())
            );
            setFilteredList(filtered);
        } else {
            setFilteredList(currentItems);
        }
    }, [currentItems, search, toggleLabel]);

    // Handle date change
    const handleDateChange = (id, field, value) => {
        if (toggleLabel === "exhibitor") {
            onUpdateExhibitorDeadline(id, field, value);
        } else {
            onUpdateCategoryDeadline(id, field, value);
        }
    };

    // Handle remove
    const handleRemove = (id) => {
        if (toggleLabel === "exhibitor") {
            onRemoveExhibitor(id);
        } else {
            onRemoveCategory(id);
        }
    };

    // Handle sync with default - sync both dates
    const handleSyncWithDefault = (id) => {
        if (toggleLabel === "exhibitor") {
            onUpdateExhibitorDeadlines(id, {
                due_date: defaultDueDate,
                reminder_date: defaultReminderDate
            });
        } else {
            onUpdateCategoryDeadlines(id, {
                due_date: defaultDueDate,
                reminder_date: defaultReminderDate
            });
        }
    };

    // Handle select from modal
    const handleSelectFromModal = (selectedItems) => {
        if (toggleLabel === "exhibitor") {
            onAddExhibitors(selectedItems);
        } else {
            onAddCategories(selectedItems);
        }
        // setShowSelectModal(false);
    };

    // Helper to convert date value for DateTimePicker
    const getDateValue = (dateValue) => {
        if (!dateValue) return null;
        if (dateValue instanceof Date) return dateValue;
        return moment(dateValue).toDate();
    };

    const columns = [
        {
            name: toggleLabel === "category" ? "Category Name" : "Exhibitor Name",
            selector: row => row?.category_name || row?.entity_name || "-",
            sortable: true,
        },
        {
            name: "Reminder Date",
            cell: row => {
                const currentReminderDate = getDateValue(row?.reminder_date);

                return (
                    <RainbowThemeContainer
                        theme={theme}
                        className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto"
                    >
                        <DateTimePicker
                            locale="en-IN"
                            id={`reminder_date_${row?.id}`}
                            name={`reminder_date_${row?.id}`}
                            formatStyle="medium"
                            value={currentReminderDate}
                            className="calendarCus"
                            icon={<img src={IconDate} alt="Calendar" />}
                            hideLabel={true}
                            okLabel="Save"
                            placeholder="Select reminder date"
                            onChange={(value) => handleDateChange(row?.id, 'reminder_date', value)}
                        />
                    </RainbowThemeContainer>
                );
            },
        },
        {
            name: "Due Date",
            cell: row => {
                const currentDueDate = getDateValue(row?.due_date);

                return (
                    <RainbowThemeContainer
                        theme={theme}
                        className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto"
                    >
                        <DateTimePicker
                            locale="en-IN"
                            id={`due_date_${row?.id}`}
                            name={`due_date_${row?.id}`}
                            formatStyle="medium"
                            value={currentDueDate}
                            className="calendarCus"
                            icon={<img src={IconDate} alt="Calendar" />}
                            hideLabel={true}
                            okLabel="Save"
                            placeholder="Select due date"
                            onChange={(value) => handleDateChange(row?.id, 'due_date', value)}
                        />
                    </RainbowThemeContainer>
                );
            },
        },
        {
            name: "Quick Action",
            cell: row => (
                <div className='d-flex align-items-center'>
                    <div
                        className='mr-2 cursor-pointer'
                        onClick={() => handleSyncWithDefault(row.id)}
                        title="Sync with default dates"
                    >
                        <img src={syncBtn} alt="Sync" style={{ width: '20px', height: '20px' }} />
                    </div>
                    <DeleteQuickButton
                        content={"Remove"}
                        onClick={() => handleRemove(row?.id)}
                    />
                </div>
            ),
        }
    ];

    const getButtonText = () => {
        return toggleLabel === "exhibitor" ? "Select Exhibitors" : "Select Categories";
    };

    const getDataToShow = () => {
        return toggleLabel === "exhibitor" ? allExhibitor : allCategory;
    };

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center my-3">
                <label htmlFor="exhibitors-categories" className="label mt-2">
                    {toggleLabel === "exhibitor" ? "Exhibitors" : "Categories"}
                </label>
                <div className='d-flex gap-3'>
                    {currentItems?.length > 0 && (
                        <SearchBar
                            containerClass="search-container task-search-container mr-3"
                            search={search}
                            setSearchFunction={setSearch}
                            searchPlaceholder={
                                toggleLabel === "exhibitor"
                                    ? "Search exhibitors..."
                                    : "Search categories..."
                            }
                        />
                    )}
                    <button
                        type="button"
                        className="k-btn cancel-btn mr-0 mt-3 mt-sm-0"
                        onClick={() => setShowSelectModal(true)}
                    >
                        {getButtonText()}
                    </button>
                </div>
            </div>

            {currentItems?.length > 0 ? (
                <BackendPaginatedDataTable
                    perPage={10}
                    totalCount={currentItems?.length}
                    rowData={filteredList?.length > 0 ? filteredList : currentItems}
                    paginationServer={false}
                    columns={columns}
                    noDataComponent={
                        <p className="mt-5 font-weight-normal no-asset-found mb-4">
                            No items Found!
                        </p>
                    }
                />
            ) : (
                <div className='empty-select-exb-cate-cont text-center'>
                    <p className='mb-0'>
                        No {toggleLabel === "exhibitor" ? "Exhibitors" : "Categories"} Selected
                    </p>
                   
                </div>
            )}

            {showSelectModal && (
                <SelectExhibitorCategoryModal
                    isOpen={showSelectModal}
                    onClose={() => setShowSelectModal(false)}
                    data={getDataToShow()}
                    toggleLabel={toggleLabel}
                    onSelect={handleSelectFromModal} 
                    alreadySelected={currentItems}
                />
            )}

            <style>{`
                .empty-select-exb-cate-cont {
                    height: 120px;
                    border: 1px dashed #C3CDDF;
                    padding: 40px;
                }
                .cursor-pointer {
                    cursor: pointer;
                }
                .task-search-container {
                    width: 300px;
                }
            `}</style>
        </div>
    );
};

export default ExhibitorsNCategoryExhibitorsTable;